export default __webpack_public_path__ + "static/media/Malaki_Portfolio4.848e46d3.webp";